var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInProgress(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.858,
    y1: 0.111,
    x2: 0.162,
    y2: 0.923,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bccff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003883"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16856",
    "data-name": "Rectangle 16856",
    width: 8.98,
    height: 16.978,
    fill: "#003883",
    stroke: "#003883",
    strokeWidth: 0.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11884",
    "data-name": "Group 11884",
    transform: "translate(-258 -153)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16857",
    "data-name": "Rectangle 16857",
    width: 36,
    height: 36,
    rx: 8,
    transform: "translate(258 153)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11821",
    "data-name": "Group 11821",
    transform: "translate(-1 -1.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11820",
    "data-name": "Group 11820",
    transform: "matrix(0.809, 0.588, -0.588, 0.809, 277.979, 162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11819",
    "data-name": "Group 11819",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37741",
    "data-name": "Path 37741",
    d: "M3.854,7.121,3.172,7.8c-.033-.007-.059,0-.071-.016C2.264,6.952,1.415,6.128.6,5.276a2.233,2.233,0,0,1-.59-1.568C0,3.3,0,2.892.006,2.484A2.484,2.484,0,0,1,2.516.01q1.973-.019,3.946,0A2.486,2.486,0,0,1,8.975,2.482c.011.377,0,.754,0,1.132A2.554,2.554,0,0,1,8.184,5.5q-3.314,3.3-6.623,6.613A1.743,1.743,0,0,0,1,13.48c.012.336-.006.673.005,1.009a1.476,1.476,0,0,0,1.465,1.467q2.019.023,4.038,0A1.475,1.475,0,0,0,7.976,14.5c.014-.407.01-.816,0-1.223a1.567,1.567,0,0,0-.511-1.108c-.7-.695-1.4-1.4-2.1-2.1-.07-.07-.136-.146-.214-.229l.687-.683c.067.058.131.106.187.162Q7.12,10.409,8.212,11.5a2.469,2.469,0,0,1,.761,1.779c0,.408.011.816,0,1.223a2.474,2.474,0,0,1-2.463,2.457q-2.018.034-4.038,0A2.477,2.477,0,0,1,.006,14.474C0,14.1,0,13.72,0,13.343A2.527,2.527,0,0,1,.788,11.48Q4.1,8.175,7.41,4.866a1.768,1.768,0,0,0,.573-1.392c-.013-.326,0-.653-.005-.979a1.479,1.479,0,0,0-1.483-1.48q-2-.019-4.007,0A1.483,1.483,0,0,0,1,2.494c0,.031,0,.061,0,.092C.995,4.424.909,4.206,2.178,5.467c.549.545,1.1,1.087,1.676,1.654",
    transform: "translate(0 0)",
    fill: "#003883",
    stroke: "#003883",
    strokeWidth: 0.6
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_37742",
    "data-name": "Path 37742",
    d: "M.394-.642c.9,1.192,3.971,3.4,3.971,4.607s-1.492.477-1.492.477S.262,4.695.262,3.489-.506-1.834.394-.642Z",
    transform: "translate(275.6 166.271)",
    fill: "#003883",
    opacity: 0.36
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/inProgress.490455d5558fb13d8ed7e24785f20253.svg";
export { ForwardRef as ReactComponent };